// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__vm32Q"};